import getAPIResponse from "./common/Common";

/**
 * Screen manager data source: {maxActiveStreams, activeCount, screens[]}.
 * Passing the tab viewId (`_vid`) marks the caller's own screen as isCurrent.
 */
export async function getScreens(viewId = null) {
	const query = viewId ? `?_vid=${encodeURIComponent(viewId)}` : "";
	return await getAPIResponse(`/api/v1/user/screens${query}`);
}
